if (MOBILE) {
    $('.left-menu .left-menu__form').appendTo( $('.why-commersant') );
}


